import * as React from 'react';

import _ from 'lodash';

import NotificationContainer from 'bundles/program-home/components/enterprise-home/NotificationContainer';
import PendingInvitationBanner from 'bundles/program-home/components/multiprogram/PendingInvitationBanner';
import type { ProgramInvitationFieldsFragment as ProgramInvitation } from 'bundles/program-home/queries/__generated__/EnterpriseHomePageQuery';

type PropsFromCaller = {
  programInvitations: ProgramInvitation[];
};

const styles = {
  banner: {
    marginBottom: 18,
  },
};

const PendingInvitations = ({ programInvitations }: PropsFromCaller) => {
  const invitations = programInvitations.filter(
    (x) => Boolean(x.userRoster?.program?.metadata.slug) && Boolean(x.userRoster?.program?.metadata.name)
  );
  const invitationsOrderedByDateDescending = _.orderBy(invitations, 'createdAt', 'desc');
  const notifications = invitationsOrderedByDateDescending.map((x) => (
    <PendingInvitationBanner
      key={x.id}
      style={styles.banner}
      // See above filter.
      programSlug={x.userRoster!.program!.metadata.slug}
      // See above filter.
      programName={x.userRoster!.program!.metadata.name}
    />
  ));

  return <NotificationContainer notificationsToShow={2}>{notifications}</NotificationContainer>;
};

export default PendingInvitations;
